import React from "react";
import { Box } from "@mui/material";

export const Brand: React.FC = () => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
    <Box
      sx={{
        width: 30, height: 30, borderRadius: "8px", backgroundColor: "#d4163c",
        color: "#fff", display: "flex", alignItems: "center",
        justifyContent: "center", fontSize: 12, fontWeight: 700,
        letterSpacing: ".04em", flexShrink: 0,
      }}
    >
      BEG
    </Box>
    <Box
      component="span"
      sx={{
        color: "#fff", fontWeight: 600, letterSpacing: ".06em",
        fontSize: { xs: 13, md: 17 }, whiteSpace: "nowrap",
      }}
    >
      BEST <Box component="span" sx={{ color: "#d4163c" }}>EURO</Box> GIRLS
    </Box>
  </Box>
);
